export default __webpack_public_path__ + "static/media/1890.14e25c0b.png";